/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Flat hairline (redesign §2.4). The template drew dividers as a fading dark gradient at
// 25% opacity, which reads as a smudge on the new flat surfaces.
import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { borderColor, transparent, white } = colors;

const divider = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      backgroundImage: "none",
      height: pxToRem(1),
      margin: `${pxToRem(16)} 0`,
      borderBottom: `${pxToRem(1)} solid ${borderColor.main}`,
      opacity: 1,
    },

    vertical: {
      backgroundColor: transparent.main,
      backgroundImage: "none",
      width: pxToRem(1),
      height: "100%",
      margin: `0 ${pxToRem(16)}`,
      borderBottom: "none",
      borderRight: `${pxToRem(1)} solid ${borderColor.main}`,
    },

    // `light` keeps its role: a divider drawn on a dark/colored block.
    light: {
      backgroundColor: transparent.main,
      backgroundImage: "none",
      borderBottom: `${pxToRem(1)} solid ${white.main}`,
      opacity: 0.25,

      "&.MuiDivider-vertical": {
        borderBottom: "none",
        borderRight: `${pxToRem(1)} solid ${white.main}`,
      },
    },
  },
};

export default divider;
